import {Component, Input, Output, EventEmitter} from '@angular/core';

/**
 * Generated class for the SendTaskComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'send-task',
  templateUrl: 'send-task.html'
})
export class SendTaskComponent {

  @Input() task;
  @Input() showAll;
  @Output() deleteTask = new EventEmitter();
  @Output() createNewSend = new EventEmitter();
  @Output() showTask = new EventEmitter();
  @Output() onResend = new EventEmitter();


  constructor() {
    console.log('Hello SendTaskComponent Component');
  }

  showDetail(){
    this.showTask.emit(this.task);
  }

  onDeleteTask(){
    this.deleteTask.emit(this.task);
  }

  onCreateTask(){
    this.createNewSend.emit(this.task);
  }
  reSendTask(){
    this.onResend.emit(this.task);
  }


}



// WEBPACK FOOTER //
// ./src/components/send-task/send-task.ts